import { createContext } from 'react';

const BreadcrumbContext = createContext();

export default BreadcrumbContext;
